import React, { Component } from 'react';
import PropTypes from 'prop-types';
// ---
import ReactSlick from 'react-slick';
// ---
// import ReactSlider from '../hero-carousel/react-slick'
import { withRadium, DetectCompact } from '../../higher-order-components'
// ---
import Wrapper from '../../components/wrapper';
import './styles.css';
// ---
import { convertPipeToBrTag, eventWithPoint, Vectors } from '../../utils';
import PickerItem from "../picker-item";
// import Slider from '../../containers/slider';

/**
 * ReactSlider 作成します
 * @param {*} settings react-slick 設定
 * @param {React.node} children 子 node list
 * @returns {React.Element} `ReactSlider`
 * @constructor
 */
export const PickerSlider = ({ settings, children }) => (
  <ReactSlick {...settings}>
    {children}
  </ReactSlick>
);

PickerSlider.propTypes = {
  settings: PropTypes.shape().isRequired,
  children: PropTypes.arrayOf(
    PropTypes.node.isRequired,
  ).isRequired,
};

withRadium(DetectCompact())(PickerSlider);

/**
 * {@link PickerItem} thumbnail
 * @param {*} props React.props
 * @returns {React.Element} {@link PickerItem}
 * @constructor
 */
export const PickerContainerItemThumbnail = (props) => (
  <PickerItem {...props} showView={false}/>
);

/**
 * {@link PickerItem} view
 * @param {*} props React.props
 * @returns {React.Element} {@link PickerItem}
 * @constructor
 */
export const PickerContainerItemView = (props) => (
  <PickerItem {...props} showView={true}/>
);

/**
 *  PickerContainer
 */
export default class PickerContainer extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    title: PropTypes.string,
    // components: PropTypes.arrayOf(PropTypes.node),
    components: PropTypes.array,
    // extend
    showTitle: PropTypes.bool,
    currentFilterId: PropTypes.string,
    filterId: PropTypes.string,
    // container filter number
    filterIndex: PropTypes.number,
    currentPickerIndex: PropTypes.number,
    titleClickCaller: PropTypes.func,
    thumbnailClickCaller: PropTypes.func,
    hasSecond: PropTypes.bool,
    filterChangeOpacityClassName: PropTypes.string,
    abortOpacityZero: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    title: null,
    components: null,
    // extend
    showTitle: false,
    currentFilterId: '',
    filterId: '',
    filterIndex: -1,
    currentPickerIndex: 0,
    titleClickCaller: null,
    thumbnailClickCaller: null,
    hasSecond: false,
    filterChangeOpacityClassName: '',
    abortOpacityZero: null,
  };
  static OPACITY_ZERO_CLASS_NAME = 'PickerContainer__content__opacity_0';
  /**
   * second filter id から first filter id を生成し 親子関係を判定します
   * @param {string} filterId my filter id
   * @param {string} currentFilterId current filter id
   * @returns {boolean} true: 親子関係
   */
  static gaveCurrentFromChild({filterId, currentFilterId}) {
    const divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    const divideId = filterId.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  }

  /**
   * filter id から view update 必要を判定します
   * @param {*} props React.props
   * @param {*} state React.state
   * @returns {{changeFilterId: boolean, sameFilterId: boolean}} change / same boolean list 返します
   */
  static getDerivedStateFromProps(props, state) {
    const notEmpty = props.currentFilterId !== '';
    let sameFilterId = notEmpty && props.currentFilterId === props.filterId;
    if (!sameFilterId) {
      sameFilterId = PickerContainer.gaveCurrentFromChild(props);
    }
    return {
      changeFilterId: notEmpty && props.currentFilterId !== state.currentFilterId,
      sameFilterId,
    };
  }

  constructor(props) {
    super(props);
    // ---
    this.onClickTitle = this.onClickTitle.bind(this);
    this.onCallClickThumbnail = this.onCallClickThumbnail.bind(this);
    const pcEachTime = 8;
    const mbEachTime = 1;
    const components = this.componentsWithOutPickerContainer();
    const componentsLength = components.length;
    this.slider = {
      view: null,
      thumbnails: {
        pc: null,
        mb: null,
        page: {
          index: {
            pc: 0,
            mb: 0,
          },
          last: {
            pc: 0,
            mb: 0,
          },
        },
        index: {
          pc: 0,
          mb: 0,
        },
        eachTime: {
          pc: pcEachTime,
          mb: mbEachTime,
        },
        // length: componentsLength,
        length: 0,
      },
    };
    // console.log('PickerContainer', props.filterId, components, this.slider.thumbnails);
    this.transitionClasses = {
      click: 'PickerContainer__thumb__btn__clicked',
      blink: 'PickerContainer__thumb__btn__blink',
    };
    this.state = {
      activateCurrent: props.currentFilterId === props.filterId,
      currentFilterId: props.currentFilterId,
      currentPickerIndex: props.currentPickerIndex,
      length: componentsLength,
      didMount: false,
      arrowPrevClass: '',
      arrowNextClass: '',
    };
    /**
     * mb - thumbnail swipe 計算に使用します
     * @type {{start: Vectors, end: Vectors}}
     */
    this.vectors = {
      start: new Vectors(),
      end: new Vectors(),
    };
    /**
     * swipe 閾値
     * @type {number}
     * @default 5
     */
    this.swipeThreshold = 5;
    /**
     * 表示されている view index
     * @type {number}
     */
    this.viewIndex = props.currentPickerIndex;
    this.onPcThumbnailClickSlickPrev = this.onPcThumbnailClickSlickPrev.bind(this);
    this.onPcThumbnailClickSlickNext = this.onPcThumbnailClickSlickNext.bind(this);
    // ---
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTouchCancel = this.onTouchCancel.bind(this);
    /**
     * responsive mb 以下サイズ - thumbnail pc - mb 連動必要判定に使用します
     * @type {number}
     */
    this.mbWidth = 767;
    /**
     * timeOut id list
     * @type {{viewChange: number, thumbnailPc: number, thumbnailMb: number}}
     */
    this.timer = {
      track: 0,
      viewChange: 0,
      thumbnailPc: 0,
      thumbnailMb: 0,
      mbOpacity: 0,
      didMount: 0,
      didUpdate: 0,
      arrow: 0,
      opacityZero: 0,
    };
    /**
     * 連打対策のための thumbnail click 可能 flag
     * @type {boolean}
     */
    this.enableThumbnailClick = true;
    this.trackIgnore = 'PickerContainer__slick-track__transition__none';
    this.components = [];
    // ---
    this.initSliderProps();
    this.onViewBeforeChange = this.onViewBeforeChange.bind(this);
    this.onViewAfterChange = this.onViewAfterChange.bind(this);
    this.onPcThumbnailBeforeChange = this.onPcThumbnailBeforeChange.bind(this);
    this.onPcThumbnailAfterChange = this.onPcThumbnailAfterChange.bind(this);
    this.onMbThumbnailBeforeChange = this.onMbThumbnailBeforeChange.bind(this);
    this.onMbThumbnailAfterChange = this.onMbThumbnailAfterChange.bind(this);
    this.slickIndex = {
      view: this.viewIndex,
      thumbnails: {
        pc: 0,
        mb: 0,
      },
    };
    this.syncCount = {
      view: 0,
      thumbnails: {
        pc: 0,
        mb: 0,
      },
    };
    this.currentFilterId = props.currentFilterId;
    // this.mbThumbnailOpacity = 0;
    // this.didMount = false;
    this.refTitle = null;
  }
  // --------------------------------------------------
  getTitleClientRect() {
    return (this.refTitle) ? this.refTitle.getBoundingClientRect() : null;
  }
  // --------------------------------------------------
  initSliderProps() {
    // const items = components.filter(component => (component.name !== 'PickerContainer'));
    const items = this.componentsWithOutPickerContainer();
    const componentsLength = items.length;
    const pcEachTime = this.slider.thumbnails.eachTime.pc;
    const mbEachTime = this.slider.thumbnails.eachTime.mb;
    this.slider.thumbnails.page.index = {
      pc: 0,
      mb: 0,
    };
    this.slider.thumbnails.page.last = {
      pc: Math.ceil(componentsLength / pcEachTime) - 1,
      mb: Math.ceil(componentsLength / mbEachTime) - 1,
    };
    this.slider.thumbnails.length = componentsLength;

    this.slider.thumbnails.index = {
      pc: 0,
      mb: 0,
    };
  }
  // --------------------------------------------------
  /**
   * vew slick beforeChange callback
   * - slick の index を把握します - `slickGoto` しても実行されないことがあるので...
   * @param {?number} currentSlideIndex data こない `undefine` なる
   * @param {number} nextSlideIndex 次の slide index - 処理が始まった
   */
  onViewBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.view = nextSlideIndex;
  }
  onViewAfterChange(currentSlideIndex) {
    this.slickIndex.view = currentSlideIndex;
  }
  onPcThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    // console.log('PickerContainer.onPcThumbnailBeforeChange ===================', this.props.filterId, nextSlideIndex);
    this.slickIndex.thumbnails.pc = nextSlideIndex;
  }

  onPcThumbnailAfterChange(currentSlideIndex) {
    // console.log('PickerContainer.onPcThumbnailAfterChange ===================', this.props.filterId, currentSlideIndex);
    this.slickIndex.thumbnails.pc = currentSlideIndex;
  }
  onMbThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.thumbnails.mb = nextSlideIndex;
  }

  onMbThumbnailAfterChange(currentSlideIndex) {
    // console.log('PickerContainer.onMbThumbnailAfterChange ===================', this.props.filterId, currentSlideIndex);
    this.slickIndex.thumbnails.mb = currentSlideIndex;
  }
  // --------------------------------------------------
  /**
   * thumbnail click callback
   * - `props.thumbnailClickCaller` を実行し thumbnail current 更新します
   * - view (slick) を update します
   * @param {string} filterId filter id
   * @param {number} pickerIndex picker index
   */
  onCallClickThumbnail(filterId, pickerIndex) {
    // console.log('PickerContainer.onCallClickThumbnail', this.props.filterId, filterId, pickerIndex);
    this.shouldViewSlickUpdate(pickerIndex);
    this.mbThumbnailCurrentWithClick(pickerIndex);
    this.callThumbnailCaller(filterId, pickerIndex);
  }

  /**
   * thumbnail callback を親 component へ伝達します
   * @param {string} filterId filter id
   * @param {number} pickerIndex thumbnail index
   */
  callThumbnailCaller(filterId, pickerIndex) {
    const { thumbnailClickCaller } = this.props;
    if (typeof thumbnailClickCaller === 'function') {
      thumbnailClickCaller.call(this, filterId, pickerIndex);
    }
  }
  /**
   * filter title click event handler
   * - `props.titleClickCaller` 通知します
   * @param {Event} event click event
   */
  onClickTitle(event) {
    event.preventDefault();
    const {titleClickCaller, filterId, filterIndex, title} = this.props;
    // console.log('PickerContainer.onClickTitle', event, filterId, filterIndex);
    if (typeof titleClickCaller === 'function') {
      titleClickCaller.call(this, filterId, filterIndex, title);
    }
  }

  // --------------------------------------------------
  // pc thumbnail slick
  onPcThumbnailClickSlickPrev(event) {
    event.preventDefault();
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    setTimeout(() => {
      this.pcThumbnailPrev();
    }, 1);
    // this.pcThumbnailPrev();
  }

  onPcThumbnailClickSlickNext(event) {
    event.preventDefault();
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    setTimeout(() => {
      this.pcThumbnailNext();
    }, 1);
    // this.pcThumbnailNext();
  }

  /**
   * pc thumbnail prev を処理します
   * - `slickPrev` bug てるので使用しません
   */
  pcThumbnailPrev() {
    const { pc } = this.slider.thumbnails;
    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.click, arrowNextClass: this.transitionClasses.blink });
      this.delayClearArrowClass();
      let page = this.slider.thumbnails.page.index.pc - 1;
      if (page < 0) {
        // page = this.slider.thumbnails.page.last.pc;
        this.pcThumbnailFirstToLast();
        return;
      }
      this.slider.thumbnails.page.index.pc = page;
      // ---
      const pcEachTime = this.slider.thumbnails.eachTime.pc;
      const pcExpectIndex = page * pcEachTime;
      // console.log('PickerContainer.pcThumbnailPrev', page, pcExpectIndex, this.slider.thumbnails.page);
      this.pcThumbnailGoTo(pcExpectIndex);
    }
  }

  /**
   * prev - first to last
   * - 独自実装計算を行います
   */
  pcThumbnailFirstToLast() {
    // prev
    // first -> last
    const { pc } = this.slider.thumbnails;
    if (pc) {
      this.slider.thumbnails.page.index.pc = this.slider.thumbnails.page.last.pc;
      const pcExpectIndex = -this.slider.thumbnails.eachTime.pc;
      // console.log('PickerContainer.pcThumbnailFirstToLast', pcExpectIndex, this.slider.thumbnails);
      this.pcThumbnailGoTo(pcExpectIndex);
    }
  }

  /**
   * pc thumbnail next を処理します
   * - `slickNext` bug てるので使用しません
   */
  pcThumbnailNext() {
    const { pc } = this.slider.thumbnails;
    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.blink, arrowNextClass: this.transitionClasses.click });
      this.delayClearArrowClass();
      // pc.slickNext();
      let page = this.slider.thumbnails.page.index.pc + 1;
      // console.log('PickerContainer.pcThumbnailNext', page, this.slider.thumbnails.page);
      if (page > this.slider.thumbnails.page.last.pc) {
        // page = 0;
        this.pcThumbnailLastToFirst();
        return;
      }
      this.slider.thumbnails.page.index.pc = page;
      // ---
      const pcEachTime = this.slider.thumbnails.eachTime.pc;
      const pcExpectIndex = page * pcEachTime;
      this.pcThumbnailGoTo(pcExpectIndex);
    }
  }

  /**
   * next - last to first
   * - 独自実装計算を行います
   */
  pcThumbnailLastToFirst() {
    // next
    // last -> top
    const { pc } = this.slider.thumbnails;
    if (pc) {
      this.slider.thumbnails.page.index.pc = 0;
      this.pcThumbnailGoTo(this.slider.thumbnails.length);
    }
  }

  /**
   * `slickGoTo` します
   * @param {number} index target index
   */
  pcThumbnailGoTo(index) {
    const { pc } = this.slider.thumbnails;
    if (pc) {
      pc.slickGoTo(index);
      this.slider.thumbnails.index.pc = index;
    }
  }

  /**
   * responsive mobile size の移動を反映します
   */
  pcThumbnailMoveByMb() {
    const { mb, pc } = this.slider.thumbnails.page.index;
    const pcEachTime = this.slider.thumbnails.eachTime.pc;
    const pcExpectPage = Math.floor(mb / pcEachTime);
    // console.log('PickerContainer.pcThumbnailMoveByMb', pcExpectPage, pc);
    if (pcExpectPage > pc) {
      this.pcThumbnailNext();
    } else if (pcExpectPage < pc) {
      this.pcThumbnailPrev();
    }
  }

  // --------------------------------------------------
  // mb thumbnail slick
  onTouchStart(event) {
    this.resetMove();
    this.vectors.start.updateWithVectors(eventWithPoint(event));
  }

  onTouchEnd(event) {
    this.vectors.end.updateWithVectors(eventWithPoint(event));
    const distanceX = this.vectors.end.distanceX(this.vectors.start);
    // swipe
    if (Math.abs(distanceX) >= this.swipeThreshold) {
      if (distanceX < 0) {
        // left
        this.mbThumbnailNext();
      } else {
        // right
        this.mbThumbnailPrev();
      }
    }
    this.resetMove();
  }

  onTouchCancel() {
    this.resetMove();
  }

  /**
   * mb swipe で 中央サムネイルを `current` にするために {@link }PickerContainer.onCallClickThumbnail} を実行します
   * - view も thumbnail に連動します
   */
  mbCallThumbnailMove() {
    const { filterId } = this.props;
    const index = this.slider.thumbnails.page.index.mb;
    this.shouldViewSlickUpdate(index);
    this.callThumbnailCaller(filterId, index);
  }

  mbThumbnailPrev(notPcMove = false) {
    const { mb }  = this.slider.thumbnails;
    if (mb) {
      // console.log('PickerContainer.mbThumbnailPrev', this.slider.thumbnails.page);
      let page = this.slider.thumbnails.page.index.mb - 1;
      if (page < 0) {
        page = this.slider.thumbnails.page.last.mb;
      }
      this.slider.thumbnails.page.index.mb = page;
      this.slider.thumbnails.index.mb = page;
      mb.slickPrev();
      // ---
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex(page, 'prev');
      // ---
      // if (!notPcMove) {
      //   this.pcThumbnailMoveByMb();
      // }
      this.mbCallThumbnailMove();
    }
  }

  mbThumbnailNext(notPcMove = false) {
    const { mb } = this.slider.thumbnails;
    if (mb) {
      let page = this.slider.thumbnails.page.index.mb + 1;
      if (page > this.slider.thumbnails.page.last.mb) {
        page = 0;
      }
      this.slider.thumbnails.page.index.mb = page;
      this.slider.thumbnails.index.mb = page;
      mb.slickNext();
      // ---
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex(page, 'next');
      // ---
      // if (!notPcMove) {
      //   this.pcThumbnailMoveByMb();
      // }
      this.mbCallThumbnailMove();
    }
  }

  // /**
  //  * mb - thumbnail slick を pc - slick 移動にシンクロさせます
  //  * @param {number} index pc 移動後の左端 picker index
  //  */
  // mbThumbnailMoveByPc(index) {
  //     const { mb } = this.slider.thumbnails;
  //     // console.log('PickerContainer.mbThumbnailMoveByPc', index);
  //     if (mb) {
  //         mb.slickGoTo(index);
  //         this.slider.thumbnails.page.mb = index;
  //         // this.viewIndex = index;
  //     }
  // }
  /**
   * pc - slick thumbnail click で mb thumbnail 移動させます
   * @param {number} index click thumbnail picker index
   * @param {string} [mode=go] move mode, 'go' || 'prev' || 'next'
   */
  mbThumbnailGoTo(index, mode = 'go') {
    const { mb } = this.slider.thumbnails;
    // console.log('PickerContainer.mbThumbnailGoTo', index, this.props.filterId);
    if (mb) {
      this.slider.thumbnails.page.index.mb = index;
      // this.viewIndex = index;
      this.slider.thumbnails.index.mb = index;
      // ---
      mb.slickGoTo(index);
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex(index, mode);
    }
  }

  /**
   * touch move value を初期化します
   */
  resetMove() {
    const { start, end } = this.vectors;
    start.reset();
    end.reset();
  }

  /**
   * MB - click thumbnail を center にします
   * @param {number} pickerIndex click thumbnail index
   */
  mbThumbnailCurrentWithClick(pickerIndex) {
    const { currentPickerIndex } = this.props;
    const last = this.slider.thumbnails.page.last.mb;
    // console.log('PickerContainer.mbThumbnailCurrentWithClick', pickerIndex, currentPickerIndex, pickerIndex === last, currentPickerIndex === 0, pickerIndex > currentPickerIndex, last);
    if (pickerIndex > currentPickerIndex) {
      if (pickerIndex === last && currentPickerIndex === 0) {
        // console.log('PickerContainer.mbThumbnailCurrentWithClick - mbThumbnailPrev');
        this.mbThumbnailPrev(true);
      } else {
        // this.mbThumbnailNext(true);
        // console.log('PickerContainer.mbThumbnailCurrentWithClick - mbThumbnailGoTo', pickerIndex);
        this.mbThumbnailGoTo(pickerIndex, 'next');
      }
    } else if (pickerIndex < currentPickerIndex) {
      if (pickerIndex === 0 && currentPickerIndex === last) {
        this.mbThumbnailNext(true);
      } else {
        this.mbThumbnailGoTo(pickerIndex, 'prev');
      }
    }
  }

  // --------------------------------------------------
  // syncPcThumbnailIndex() {
  //   clearTimeout(this.timer.thumbnailPc);
  //   const slider = this.slider.thumbnails.pc;
  //   if (this.syncCount.thumbnails.pc > 50 || !slider || this.slider.thumbnails.index.pc === this.slickIndex.thumbnails.pc) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.thumbnails.pc = this.slider.thumbnails.index.pc;
  //     return;
  //   }
  //   this.syncCount.thumbnails.pc += 1;
  //   this.timer.thumbnailPc = setTimeout(() => {
  //     this.pcThumbnailGoTo(0);
  //     // console.log('PickerContainer.syncPcThumbnailIndex *** timeOut', this.props.filterId, this.syncCount.thumbnails.pc, this.slider.thumbnails.index.pc, this.slickIndex.thumbnails.pc, Date.now());
  //     this.syncPcThumbnailIndex();
  //   }, 16);
  // }
  // syncMbThumbnailIndex(index = 0, mode = 'go') {
  //   clearTimeout(this.timer.thumbnailMb);
  //   const slider = this.slider.thumbnails.mb;
  //   if (this.syncCount.thumbnails.mb > 50 || !slider || this.slider.thumbnails.index.mb === this.slickIndex.thumbnails.mb) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.thumbnails.mb = this.slider.thumbnails.index.mb;
  //     return;
  //   }
  //   this.syncCount.thumbnails.mb += 1;
  //   this.timer.thumbnailMb = setTimeout(() => {
  //     // this.mbThumbnailGoTo(index);
  //     switch (mode) {
  //       case 'prev': {
  //         slider.slickPrev();
  //         break;
  //       }
  //       case 'next': {
  //         slider.slickNext();
  //         break;
  //       }
  //       case 'go':
  //       default:{
  //         slider.slickGoTo(index);
  //         break;
  //       }
  //     }
  //     // console.log('PickerContainer.syncMbThumbnailIndex ::: timeOut', this.props.filterId, index, mode, this.syncCount.thumbnails.mb, this.slider.thumbnails.index.mb, this.slickIndex.thumbnails.mb, Date.now());
  //     this.syncMbThumbnailIndex(index, mode);
  //   }, 16);
  // }

  resetThumbnail(pc) {
    const slick = pc ? this.slider.thumbnails.pc: this.slider.thumbnails.mb;
    if (!slick) {
      return;
    }
    // console.log('PickerContainer.resetThumbnail', this.props.filterId, pc, slick);
    if (pc) {
      this.pcThumbnailGoTo(0);
      this.slider.thumbnails.page.index.pc = 0;
      this.slider.thumbnails.index.pc = 0;
      // this.syncCount.thumbnails.pc = 0;
      // this.syncPcThumbnailIndex();
    } else {
      this.mbThumbnailGoTo(0);
      this.slider.thumbnails.page.index.mb = 0;
      this.slider.thumbnails.index.mb = 0;
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex();
    }
  }

  resetThumbnails() {
    // console.log('PickerContainer.resetThumbnails', this.props.filterId, Date.now());
    this.resetThumbnail(true);
    this.resetThumbnail(false);
  }
  // --------------------------------------------------
  // view slick
  // /**
  //  * slick が処理中だと命令を無視するようなので実行できるまでしつこく待機する
  //  */
  // syncViewIndex() {
  //   clearTimeout(this.timer.viewChange);
  //   const view = this.slider.view;
  //   if (this.syncCount.view > 50 || !view || this.viewIndex === this.slickIndex.view) {
  //     return;
  //   }
  //   this.syncCount.view += 1;
  //   this.timer.viewChange = setTimeout(() => {
  //     view.slickGoTo(this.viewIndex);
  //     // console.log('PickerContainer.syncViewIndex -- timeOut', this.viewIndex, this.slickIndex.view, Date.now());
  //     this.syncViewIndex();
  //   }, 16);
  // }
  /**
   * `currentPickerIndex` value で view を変更します
   * - view - slick 移動します
   * @param {number} index pickerIndex -> 表示する view index
   */
  shouldViewSlickUpdate(index) {
    const view = this.slider.view;
    if (!view) {
      return;
    }
    clearTimeout(this.timer.viewChange);
    this.viewIndex = index;
    view.slickGoTo(index);
    // // pc サイズのときに mb （非表示）thumbnail を移動します
    // if (window.innerWidth > this.mbWidth) {
    //   this.mbThumbnailGoTo(index);
    // }
    // this.syncCount.view = 0;
    // this.syncViewIndex();
  }
  resetViewSlick() {
    this.viewIndex = 0;
    const { view } = this.slider;
    if (view) {
      view.slickGoTo(0);
      // this.syncCount.view = 0;
      // this.syncViewIndex();
    }
  }
  // --------------------------------------------------
  // abortTrackTransition() {
  //   // console.log('PickerContainer.abortTrackTransition +++++', this.props.filterId, Date.now());
  //   document.body.classList.add(this.trackIgnore);
  // }
  // enableTrackTransition() {
  //   // console.log('PickerContainer.enableTrackTransition ------', this.props.filterId, Date.now());
  //   document.body.classList.remove(this.trackIgnore);
  // }
  // delayEnableTrackTransition(delay = 516) {
  //   clearTimeout(this.timer.track);
  //   this.timer.track = setTimeout(() => {
  //     this.enableTrackTransition();
  //   }, delay);
  // }
  // --------------------------------------------------
  abortOpacityZero() {
    // document.body.classList.remove(this.opacityZeroClassName);
    // this.setState({ filterChangeOpacityClassName: '' });
    const { abortOpacityZero } = this.props;
    // console.log('PickerContainer.abortOpacityZero --------------- remove', this.props.filterId, Date.now());
    if (typeof abortOpacityZero === 'function') {
      abortOpacityZero.call(this);
    }
  }
  delayAbortOpacityZero(delay = 320) {
    this.timer.opacityZero = setTimeout(() => {
      this.abortOpacityZero();
    }, delay);
  }
  // --------------------------------------------------
  /**
   * state を変更するかをチェックします
   * @param {boolean} activateCurrent `state.activateCurrent` と違っていたら `setState` します
   */
  willChangeStateCurrent(activateCurrent) {
    const {
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    // console.log(`PickerContainer.willChangeStateCurrent - activateCurrent(${activateCurrent})`, currentFilterId, this.props.filterId, this.state.activateCurrent);
    if (this.state.activateCurrent !== activateCurrent) {
      this.shouldViewSlickUpdate(this.viewIndex);
      this.setState({ activateCurrent, currentFilterId, currentPickerIndex });
    }
  }
  // --------------------------------------------------
  afterMountShowSlick() {
    // console.log('PickerContainer.afterMountShowSlick ===========');
    this.setState({ didMount: true });
  }
  // --------------------------------------------------
  clearArrowClass() {
    // console.log('FeatureCategoryContainerHorizontal.clearArrowClass');
    clearTimeout(this.timer.arrow);
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
  }
  delayClearArrowClass(delay = 1750) {
    clearTimeout(this.timer.arrow);
    this.timer.arrow = setTimeout(() => {
      this.clearArrowClass();
    }, delay);
  }
  // --------------------------------------------------
  /**
   * props.components から {@link PickerContainer} を除いたリストを作成します
   * @returns {Array<*>} {@link PickerContainer} を除いたリストを返します
   */
  componentsWithOutPickerContainer() {
    const { components } = this.props;
    const list = Array.isArray(components) ? components: [];
    return list.filter(component => (component.name !== 'PickerContainer'));
  }
  // --------------------------------------------------
  componentDidUpdate(prevProps) {
    const { sameFilterId } = PickerContainer.getDerivedStateFromProps(this.props, this.state);
    this.willChangeStateCurrent(sameFilterId);
    // filter id が変わったら slick 表示位置をリセットする
    if (prevProps.currentFilterId !== this.props.currentFilterId) {
      // console.log('PickerContainer.componentDidUpdate', sameFilterId, this.props.filterId, this.props.currentFilterId, prevProps.currentFilterId);
      this.currentFilterId = this.props.currentFilterId;
      this.initSliderProps();
      // ---
      // this.abortTrackTransition();
      // this.delayEnableTrackTransition();
      // ---
      this.resetViewSlick();
      this.resetThumbnails();
      // ---
      if (this.props.currentFilterId === this.props.filterId) {
        // const delay = this.state.didMount ? 640 : 1000;
        this.delayAbortOpacityZero(500);
      }
    }
  }
  componentDidMount() {
    // this.enableTrackTransition();
    // this.abortOpacityZero();
    // this.timer.didMount = setTimeout(() => {
    //   this.afterMountShowSlick();
    //   this.delayAbortOpacityZero(1000);
    // }, 1000);

    this.timer.didMount = setTimeout(() => {
      this.afterMountShowSlick();
      this.delayAbortOpacityZero(16);
    }, 0);
  }
  componentWillUnmount() {
    // clear timer
    Object.values(this.timer).map(id => (clearTimeout(id)));
  }

  // --------------------------------------------------
  // title
  renderTitle() {
    const {
      title,
      filterId,
      hasSecond,
      // currentFilterId,
    } = this.props;

    if (!title) {
      return null;
    }

    // const {
    //   activateCurrent,
    // } = this.state;
    const { sameFilterId } = PickerContainer.getDerivedStateFromProps(this.props, this.state);
    // const activateCurrent = sameFilterId;
    const selectedClass = sameFilterId ? 'PickerContainer__title__selected': '';
    const hasSecondClass = hasSecond ? 'PickerContainer__title__has_child': '';
    // console.log('PickerContainer.renderTitle', filterId, this.props.currentFilterId, activateCurrent);

    const titleHtml = title || '';
    return (
      <div
        className={`PickerContainer__title PickerContainer__title-${filterId} ${selectedClass} ${hasSecondClass}`}
        role="presentation"
        onClick={this.onClickTitle}
        dangerouslySetInnerHTML={{__html: convertPipeToBrTag(titleHtml)}}
        ref={component => (this.refTitle = component)}
      />
    );
  }

  // --------------------------------------------------
  // thumbnail
  renderThumbnailSlickMb(components) {
    const {
      filterId,
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    // ---
    const settings = {
      arrows: false,
      autoplay: false,
      ref: (component) => (this.slider.thumbnails.mb = component),
      initialSlide: 0,
      swipeToSlide: false,

      // swipe: false,
      // touchMove: false,
      swipe: true,
      touchMove: true,

      useTransform: false,
      // ---
      variableWidth: false,
      fade: false,
      // rows: 1,
      slidesPerRow: 1,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
      className: 'picker-thumbnail-slick-mb',
      beforeChange: this.onMbThumbnailBeforeChange,
      afterChange: this.onMbThumbnailAfterChange,
      waitForAnimate: false,
    };
    // ---
    const { didMount } = this.state;
    const style = didMount ? null : { overflow: 'hidden', maxHeight: '0' };
    // ---
    return (
      <div className="PickerContainer__thumb__container-mb PickerContainer__thumb__carousel" style={style}>
        <div
          className="PickerContainer__thumb__block"
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.onTouchEnd}
          onTouchCancel={this.onTouchCancel}
        >
          <div className="PickerContainer__thumb__item__wrap">
            <PickerSlider settings={settings}>
              {
                components.map((component, index) => {
                  const id = `${filterId}-${index}`;
                  const props = Object.assign({}, component.props);
                  return (
                    <PickerContainerItemThumbnail
                      key={id}
                      {...props}
                      pickerIndex={index}
                      currentPickerId={`${currentFilterId}-${currentPickerIndex}`}
                      pickerId={id}
                      thumbnailClickCaller={this.onCallClickThumbnail}
                      currentFilterId={currentFilterId}
                      filterId={filterId}
                      currentPickerIndex={currentPickerIndex}
                      showMb
                    />
                  );
                })
              }
            </PickerSlider>
          </div>
        </div>
      </div>
    );
  }
  renderThumbnailFlatMb(components) {
    const {
      filterId,
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    // ---

    return (
      <div className="PickerContainer__thumb__container-mb">
        <div
          className="PickerContainer__thumb__block"
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.onTouchEnd}
          onTouchCancel={this.onTouchCancel}
        >
          <div className="PickerContainer__thumb__item__wrap">
            {
              components.map((component, index) => {
                const id = `${filterId}-${index}`;
                const props = Object.assign({}, component.props);
                return (
                  <PickerContainerItemThumbnail
                    key={id}
                    {...props}
                    pickerIndex={index}
                    currentPickerId={`${currentFilterId}-${currentPickerIndex}`}
                    pickerId={id}
                    thumbnailClickCaller={this.onCallClickThumbnail}
                    currentFilterId={currentFilterId}
                    filterId={filterId}
                    currentPickerIndex={currentPickerIndex}
                    showMb
                  />
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }

  renderThumbnailMb(components) {
    return components.length < 3 ? this.renderThumbnailFlatMb(components): this.renderThumbnailSlickMb(components);
  }
  // --------------------------------------------------
  renderThumbnailSlickPc(components) {
    const {
      filterId,
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    // ---
    const settings = {
      arrows: false,
      autoplay: false,
      ref: (component) => (this.slider.thumbnails.pc = component),
      // initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      className: 'picker-thumbnail-slick-pc',
      // ---
      fade: false,
      useTransform: false,
      variableWidth: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      useCSS: true,
      beforeChange: this.onPcThumbnailBeforeChange,
      afterChange: this.onPcThumbnailAfterChange,
      waitForAnimate: false,
    };
    // ---
    const { didMount } = this.state;
    const style = didMount ? null : { overflow: 'hidden', maxHeight: '0' };
    const { arrowNextClass, arrowPrevClass } = this.state;
    // ---
    return (
      <div className="PickerContainer__thumb__container-pc PickerContainer__thumb__carousel" style={style}>
        <div className="PickerContainer__thumb__block">
          <div className="PickerContainer__thumb__item__wrap">
            <PickerSlider settings={settings}>
              {
                components.map((component, index) => {
                  const id = `${filterId}-${index}`;
                  const props = Object.assign({}, component.props);
                  return (
                    <PickerContainerItemThumbnail
                      key={id}
                      {...props}
                      pickerIndex={index}
                      currentPickerId={`${currentFilterId}-${currentPickerIndex}`}
                      pickerId={id}
                      thumbnailClickCaller={this.onCallClickThumbnail}
                      currentFilterId={currentFilterId}
                      filterId={filterId}
                      currentPickerIndex={currentPickerIndex}
                    />
                  );
                })
              }
            </PickerSlider>
          </div>
        </div>
        <div className="PickerContainer__thumb__controls">
          <button
            className={`PickerContainer__thumb__btn PickerContainer__thumb__prev ${arrowPrevClass}`}
            type="button"
            onClick={this.onPcThumbnailClickSlickPrev}
          >
            <i/>
          </button>
          <button
            className={`PickerContainer__thumb__btn PickerContainer__thumb__next ${arrowNextClass}`}
            type="button"
            onClick={this.onPcThumbnailClickSlickNext}
          >
            <i/>
          </button>
        </div>
      </div>
    );
  }

  // --------------------------------------------------
  renderThumbnailFlatPc(components) {
    const {
      filterId,
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    // ---
    return (
      <div className="PickerContainer__thumb__container-pc PickerContainer__thumb__container-pc__flat">
        <div className="PickerContainer__thumb__block">
          <div className="PickerContainer__thumb__item__wrap">
            {
              components.map((component, index) => {
                const id = `${filterId}-${index}`;
                const props = Object.assign({}, component.props);
                return (
                  <PickerContainerItemThumbnail
                    key={id}
                    {...props}
                    pickerIndex={index}
                    currentPickerId={`${currentFilterId}-${currentPickerIndex}`}
                    pickerId={id}
                    thumbnailClickCaller={this.onCallClickThumbnail}
                    currentFilterId={currentFilterId}
                    filterId={filterId}
                    currentPickerIndex={currentPickerIndex}
                  />
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }

  /**
   * pc - thumbnail component 出力します
   * - length 9 未満 - {@link PickerContainer.renderThumbnailFlatPc}
   * - 9 以上 - {@link PickerContainer.renderThumbnailSlickPc}
   * @param {Array<*>} components 出力対象 {@link PickerItem} list
   * @returns {*}
   */
  renderThumbnailPc(components) {
    return components.length < 9 ? this.renderThumbnailFlatPc(components): this.renderThumbnailSlickPc(components);
  }

  // --------------------------------------------------
  /**
   * thumbnail component
   * - pc / mb 出力分岐します
   * @param {Array<*>} components 出力対象 {@link PickerItem} list
   * @returns {*} `div.PickerContainer__thumbnails__root`
   */
  renderThumbnail(components) {
    if (components.length <= 1) {
      return null;
    }
    return (
      <div className="PickerContainer__thumbnails__root">
        {this.renderThumbnailPc(components)}
        {this.renderThumbnailMb(components)}
      </div>
    );
  }

  // --------------------------------------------------
  // view
  /**
   * view slick - length 1 以外
   * @param {Array<*>} components 出力対象 {@link PickerItem} list
   * @returns {React.Element} {@link PickerSlider}
   */
  renderViewSlick(components) {
    const {
      filterId,
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    const settings = {
      speed: 1500,
      arrows: false,
      autoplay: false,
      ref: (component) => (this.slider.view = component),
      fade: true,
      initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      useTransform: false,
      // ---
      variableWidth: false,
      className: filterId,
      beforeChange: this.onViewBeforeChange,
      afterChange: this.onViewAfterChange,
      waitForAnimate: false,
    };
    return (
      <PickerSlider settings={settings}>
        {
          components.map((component, index) => {
            const id = `${filterId}-${index}`;
            const props = Object.assign({}, component.props);
            return (
              <PickerContainerItemView
                key={id}
                {...props}
                pickerIndex={index}
                currentPickerId={`${currentFilterId}-${currentPickerIndex}`}
                pickerId={id}
                currentPickerIndex={currentPickerIndex}
                filterId={filterId}
                currentFilterId={currentFilterId}
                inCarousel
              />
            );
          })
        }
      </PickerSlider>
    );
  }

  /**
   * view 1個の時は slick いらない
   * */
  renderViewSingle(components) {
    const component = components[0];
    const props = Object.assign({}, component.props);
    const {
      filterId,
      currentFilterId,
      currentPickerIndex,
    } = this.props;
    return (
      <PickerContainerItemView
        {...props}
        pickerIndex={0}
        currentPickerId={`${currentFilterId}-${currentPickerIndex}`}
        pickerId={`${filterId}-0`}
        currentPickerIndex={currentPickerIndex}
      />
    );
  }

  renderView(components) {
    return components.length === 1 ? this.renderViewSingle(components): this.renderViewSlick(components);
  }

  // --------------------------------------------------
  render() {
    const {
      containerId,
      containerClass,
      // title,
      showTitle,
      filterId,
      currentFilterId,
      filterChangeOpacityClassName,
    } = this.props;
    // ---
    if (showTitle) {
      return this.renderTitle();
    }
    // ---
    const components = this.componentsWithOutPickerContainer();
    this.components = components;
    // ---
    // console.log(`PickerContainer.render - filterChangeOpacityClassName: [${filterChangeOpacityClassName}]`, filterId, Date.now());
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className={`PickerContainer__transition_root ${filterChangeOpacityClassName}`}>
          <div
            className={`PickerContainer ${filterId}`}
            data-current={currentFilterId}
          >
            {/* thumbnails */}
            {this.renderThumbnail(components)}
            {/* views */}
            <div className="PickerContainer__view">
              <div className="PickerContainer__view__item">
                {this.renderView(components)}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/picker-container/index.jsx